export default function isImageFile(filename = '') {
  if (typeof filename !== 'string') return false;
  const clean = filename.split('?')[0].toLowerCase();
  return /\.(jpe?g|png|gif|webp|avif|heic|heif)$/i.test(clean);
}
